import React from 'react';

const Footer: React.FC = () => (
  <footer
    style={{
      background: '#222324',
      padding: '32px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 12,
    }}
  >
    <img src="/logo-white.svg" alt="City of Boroondara" style={{ height: 32 }} />
    <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 12 }}>
      &copy; {new Date().getFullYear()} City of Boroondara. All rights reserved.
    </span>
  </footer>
);

export default Footer;
